import { z } from "zod";

export const RegisterSalonServiceFormSchema = z.object({
  name: z.string().min(3, { message: "Nome inválido" }),
  value: z
    .number({
      required_error: "Valor é obrigatório",
      invalid_type_error: "Valor inválido",
    })
    .max(1000000, "O valor máximo permitido é R$ 1.000.000,00"),
  duration: z
    .string()
    .regex(/^(0[0-9]|1[0-9]|2[0-3])[0-5][0-9]$/, {
      message: "Duração inválida",
    })
    .refine((value) => (value === "0000" ? false : true), {
      message: "Duração inválida",
    }),
  observation: z
    .string()
    .max(255, {
      message: "A observação deve ter no máximo 255 caracteres",
    })
    .optional(),
});
